(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["camo-hero-slider"] && !Shopify.designMode) return;
  try {
    
	(() => {
		const selectors = {
			root: '[data-camo-hero-slider]',
			slide: '[data-camo-hero-slide]',
			dot: '[data-camo-hero-dot]'
		};

		const initSlider = (root) => {
			if (root.dataset.camoHeroReady === 'true') return;

			const slides = Array.from(root.querySelectorAll(selectors.slide));
			const dots = Array.from(root.querySelectorAll(selectors.dot));
			const autoplay = root.dataset.autoplay === 'true';
			const delay = Number(root.dataset.delay) || 5000;
			let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
			let timer = null;
			let pointerStart = null;
			let pointerStartY = null;
			let pointerCurrent = null;
			let pointerCurrentY = null;
			let preventClick = false;

			const setActive = (index) => {
				if (slides.length === 0) return;

				activeIndex = (index + slides.length) % slides.length;

				slides.forEach((slide, slideIndex) => {
					const isActive = slideIndex === activeIndex;
					slide.classList.toggle('is-active', isActive);
					slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');

					if (isActive) {
						const desktopAspect = slide.style.getPropertyValue('--camo-hero-aspect-desktop');
						const mobileAspect = slide.style.getPropertyValue('--camo-hero-aspect-mobile');
						if (desktopAspect) root.style.setProperty('--camo-hero-aspect-desktop', desktopAspect);
						if (mobileAspect) root.style.setProperty('--camo-hero-aspect-mobile', mobileAspect);
					}
				});

				dots.forEach((dot, dotIndex) => {
					const isActive = dotIndex === activeIndex;
					dot.classList.toggle('is-active', isActive);
					dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
				});
			};

			const clearSwipeClasses = () => {
				root.classList.remove('is-swipe-next', 'is-swipe-prev');
				slides.forEach((slide) => {
					slide.classList.remove('is-swipe-from', 'is-swipe-to');
				});
			};

			const slideTo = (index, direction) => {
				if (slides.length <= 1) return;

				const fromIndex = activeIndex;
				const toIndex = (index + slides.length) % slides.length;
				if (fromIndex === toIndex) return;

				clearSwipeClasses();
				root.classList.add(direction === 'prev' ? 'is-swipe-prev' : 'is-swipe-next');
				slides[fromIndex].classList.add('is-swipe-from');
				slides[toIndex].classList.add('is-swipe-to');
				slides[toIndex].setAttribute('aria-hidden', 'false');
				activeIndex = toIndex;

				dots.forEach((dot, dotIndex) => {
					const isActive = dotIndex === activeIndex;
					dot.classList.toggle('is-active', isActive);
					dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
				});

				const desktopAspect = slides[toIndex].style.getPropertyValue('--camo-hero-aspect-desktop');
				const mobileAspect = slides[toIndex].style.getPropertyValue('--camo-hero-aspect-mobile');
				if (desktopAspect) root.style.setProperty('--camo-hero-aspect-desktop', desktopAspect);
				if (mobileAspect) root.style.setProperty('--camo-hero-aspect-mobile', mobileAspect);

				window.setTimeout(() => {
					clearSwipeClasses();
					setActive(toIndex);
				}, 430);
			};

			const stop = () => {
				if (timer) window.clearInterval(timer);
				timer = null;
			};

			const start = () => {
				stop();
				if (autoplay && slides.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
					timer = window.setInterval(() => setActive(activeIndex + 1), delay);
				}
			};

			const goTo = (index) => {
				setActive(index);
				start();
			};

			dots.forEach((dot) => {
				dot.addEventListener('click', () => goTo(Number(dot.dataset.slideIndex)));
			});

			root.addEventListener('pointerdown', (event) => {
				if (!event.isPrimary) return;
				pointerStart = event.clientX;
				pointerStartY = event.clientY;
				pointerCurrent = event.clientX;
				pointerCurrentY = event.clientY;
				preventClick = false;
				root.classList.add('is-dragging');
			});

			root.addEventListener('pointermove', (event) => {
				if (pointerStart === null || !event.isPrimary) return;
				pointerCurrent = event.clientX;
				pointerCurrentY = event.clientY;
				const distance = pointerCurrent - pointerStart;
				const verticalDistance = Math.abs(pointerCurrentY - pointerStartY);
				const horizontalDistance = Math.abs(distance);
				if (horizontalDistance > 10 && horizontalDistance > verticalDistance) {
					event.preventDefault();
				}
			});

			root.addEventListener('pointerup', (event) => {
				if (pointerStart === null) return;
				const distance = (pointerCurrent || event.clientX) - pointerStart;
				const verticalDistance = Math.abs((pointerCurrentY || event.clientY) - pointerStartY);
				const horizontalDistance = Math.abs(distance);
				pointerStart = null;
				pointerStartY = null;
				pointerCurrent = null;
				pointerCurrentY = null;
				root.classList.remove('is-dragging');

				if (horizontalDistance > 32 && horizontalDistance > verticalDistance) {
					preventClick = true;
					stop();
					if (distance < 0) {
						slideTo(activeIndex + 1, 'next');
					} else {
						slideTo(activeIndex - 1, 'prev');
					}
					start();
					window.setTimeout(() => {
						preventClick = false;
					}, 300);
				}
			});

			root.addEventListener('pointercancel', () => {
				pointerStart = null;
				pointerStartY = null;
				pointerCurrent = null;
				pointerCurrentY = null;
				root.classList.remove('is-dragging');
			});

			root.addEventListener('click', (event) => {
				if (event.target.closest('[data-camo-hero-dot], .camo-hero-slider__button')) return;

				if (preventClick) {
					event.preventDefault();
					event.stopPropagation();
					return;
				}

				const activeSlide = slides[activeIndex];
				const slideLink = activeSlide ? activeSlide.dataset.slideLink : '';
				if (!slideLink) return;

				event.preventDefault();
				window.location.href = slideLink;
			}, true);

			root.addEventListener('dragstart', (event) => {
				event.preventDefault();
			});

			document.addEventListener('shopify:block:select', (event) => {
				if (!root.contains(event.target)) return;
				const selectedSlide = event.target.closest(selectors.slide);
				if (!selectedSlide) return;
				stop();
				setActive(Number(selectedSlide.dataset.slideIndex));
			});

			root.dataset.camoHeroReady = 'true';
			setActive(activeIndex);
			start();
		};

		const initAllSliders = () => {
			document.querySelectorAll(selectors.root).forEach(initSlider);
		};

		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', initAllSliders);
		} else {
			initAllSliders();
		}

		window.addEventListener('load', initAllSliders);

		document.addEventListener('shopify:section:load', (event) => {
			const loadedRoot = event.target.querySelector(selectors.root);
			if (loadedRoot) initSlider(loadedRoot);
		});
	})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dual-promo-banners"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-dual-promo-banners]';

    const initSection = (section) => {
      if (!section || section.dataset.dualPromoReady === 'true') return;

      section.dataset.dualPromoReady = 'true';
      section.classList.add('is-ready');

      if (!section.classList.contains('dual-promo-banners--animate')) {
        section.classList.add('is-visible');
        return;
      }

      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        section.classList.add('is-visible');
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          section.classList.add('is-visible');
          observer.disconnect();
        });
      }, {
        rootMargin: '0px 0px -6% 0px',
        threshold: 0.08
      });

      observer.observe(section);
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll(selector).forEach(initSection);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
